import { useItem } from "../../../fetch/fetch.item.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import FilterIcon from "../../filter/core/FilterIcon";
import FilterTitle from "../../filter/core/FilterTitle";
import FilterUnit from "../../filter/core/FilterUnit";
import FilterFetch from "../../filter/fetch/FilterFetch";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";

const ItemAttributeTable = ({ itemId }: { itemId: string }) => {
  const { item, isLoading, isError } = useItem(itemId, EMPTY_ITEM);
  if (isLoading) return LOADING_CIRCLE;
  if (isError) return <ErrMessage message={isError} />;
  if (!item.categoryData || item.categoryData.length === 0) return null;
  return (
    <table className="table text-xl">
      <tbody>
        {item.categoryData.map(({ filterId, value }) => (
          <tr key={filterId} className="grid-cols-2">
            <th className="inline-flex items-center gap-2 w-full">
              <FilterIcon id={filterId} />
              <FilterTitle id={filterId} />
            </th>
            <td className="opacity-70 ">
              {value}{" "}
              <FilterFetch filterId={filterId} fallback={null}>
                {(filter) => filter.unit && <FilterUnit id={filterId} />}
              </FilterFetch>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
export default ItemAttributeTable;
